module.exports = __webpack_public_path__ + "img/section9.27f8af2f.png";